import React from 'react'
import { useState } from 'react'
import { Block, Image, Inline } from '@/components/crRender'
import placeholderImg from '@/assets/images/Not_available.jpg'
import { FileUploadField } from '../../shared'
import { useTranslation } from 'react-i18next'
import ActionBtn from '@/components/ActionBtn'
import './style.css'
const FileDocRow = ({ docInfo, updateTechnology }) => {

    const [isEditImg, setIsEditImg] = useState(false)
    const { t } = useTranslation()

    return (
        <div className="technology-item-card col-lg-6 mb-2" >
            <div className="technology-item-card-content">
                <div >
                    <Inline className="doc-name" isRender={!!docInfo?.name}>
                        {t(docInfo?.name)}
                    </Inline>
                    <Block isRender={!isEditImg} className="row relative-container">
                        <Image placeholder={placeholderImg} src={window.API_URL + docInfo?.data[docInfo?.data?.length - 1]?.name} />
                        <ActionBtn
                            icon="qlementine-icons:cross-16"
                            className="remove-tech-btn remove-tech-image-btn pointer"
                            onApply={() => setIsEditImg(true)} />
                    </Block>

                    <Block isRender={!!isEditImg}>
                        <FileUploadField
                            className="col-lg-12"
                            formHandler={(name, value) => updateTechnology(docInfo?.name, name, value)}
                            name="picture"
                            id={`technology-picture-${docInfo?.name}`}
                            accept="image/*"
                            maxFiles={1}
                            value={docInfo?.picture || ''}
                        />
                    </Block>
                </div>
            </div>
        </div>
    )
}

export default FileDocRow